import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewColumn } from '../../view-column';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent {

  @Input() breadCrumbs: ViewColumn[];

  @Output() crumb = new EventEmitter<number>();

  constructor() { }

  onClick(e: number) {
    this.crumb.emit(e);
  }

}
